import type { ReactNode } from "react";
import { CheckOutlined } from "@ant-design/icons";

interface ProfileMenuRowProps {
  icon: ReactNode;
  label: ReactNode;
  onClick: () => void;
  active?: boolean;
  danger?: boolean;
  disabled?: boolean;
  /** Втори ред под етикета — напр. защо редът е изключен. */
  description?: string;
  trailing?: ReactNode;
}

// Ред в профилното меню и в модалите „Тема"/„Език". Hover-ът е само с
// `hover:` — JS hover „залепва" на телефон.
export default function ProfileMenuRow({
  icon,
  label,
  onClick,
  active,
  danger,
  disabled,
  description,
  trailing,
}: ProfileMenuRowProps) {
  const tone = active
    ? "cursor-pointer bg-brand-tint text-brand-ink"
    : disabled
      ? "cursor-not-allowed bg-transparent text-muted"
      : danger
        ? "cursor-pointer bg-transparent text-ink hover:bg-danger-tint hover:text-danger-ink"
        : "cursor-pointer bg-transparent text-ink hover:bg-shade-1";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`flex w-full items-center gap-2.5 rounded-lg border-none px-3 py-2.5 text-left text-[13px] font-semibold tracking-[-0.1px] transition-colors duration-[120ms] ${tone}`}
    >
      <span className="flex w-4 shrink-0 items-center justify-center">
        {icon}
      </span>
      <span className="flex min-w-0 flex-1 flex-col">
        {label}
        {description && (
          <span className="mt-0.5 text-[11.5px] font-medium text-muted">
            {description}
          </span>
        )}
      </span>
      {trailing}
      {active && <CheckOutlined className="text-[12px] text-brand-ink" />}
    </button>
  );
}
